module.exports = __webpack_public_path__ + "0456b7adf972e6f8a133c9ebb51e7f60.svg";